export default __webpack_public_path__ + "static/media/procedure11.70115d5a.jpg";